<div class="modal cancel-replace-modal">
  <div class="mask"></div>
  <div class="limitada container">
    <div class="row title {{ saleType }}">
      {{
        data.isReplace ? 'Detener orden y generar una nueva' : 'Cancelar orden'
      }}
    </div>

    <div class="row mfa-message" *ngIf="mfaType === 0">
      Ingresa el código que enviamos a tu teléfono celular para cambiar a sesión
      operativa y realizar tu operación
    </div>

    <div class="row mfa-message" *ngIf="mfaType === 1">
      Ingresa el código que genero tu app de autenticación para cambiar a sesión
      operativa y realizar tu operación
    </div>

    <div
      class="row token-request simple-input"
      *ngIf="data.isReadAndWrite === false"
    >
      <input
        type="text"
        class="token"
        NumberOnly
        required
        matInput
        maxlength="6"
        [(ngModel)]="token"
        (ngModelChange)="changeToken($event)"
        autocomplete="off"
      />
      <label>Código</label>
    </div>

    <div class="actions">
      <button mat-button mat-dialog-close class="btn-cancel">CERRAR</button>
      <button
        (click)="close(true, data.isReplace)"
        class="btn-movement"
        [disabled]="!isValidToken"
      >
        CONFIRMAR
      </button>
    </div>
  </div>
</div>
